<!-- AG Grid Angular Component Clientside rendering -->
<div *ngIf="isClientSide">
  <div
    [joyrideStep]="stepCountAg ? stepCountAg : 'ag_step'"
    [title]="stepTitleAg"
    [text]="stepTextAg"
    [stepPosition]="stepPositionAg"
    (prev)="onGridPrev()"
    (next)="onGridNext()"
  >
    <ag-grid-angular
      [suppressRowHoverHighlight]="true"
      class="ag-theme-alpine"
      class="{{ class }}"
      [columnDefs]="columnDefs"
      [autoGroupColumnDef]="autoGroupColumnDef"
      (gridReady)="onGridReady($event)"
      [sortingOrder]="['asc', 'desc']"
      [frameworkComponents]="frameworkComponents"
      [rowSelection]="'single'"
      [animateRows]="true"
      [rowData]="rowData"
      [editType]="isInlineGrid || isEOLGrid ? editType : undefined"
      [context]="context"
      [detailRowHeight]="detailRowHeight"
      [ngClass]="{ isInlineGrid: isInlineGrid }"
      [masterDetail]="false"
      [domLayout]="rowData?.length > 10 && !isInlineGrid ? 'print' : 'autoHeight'"
      [statusBar]="statusBar"
      suppressMovable
      [pagination]="!hidePagination"
      suppressPaginationPanel
      [stopEditingWhenCellsLoseFocus]="isInlineGrid || isEOLGrid ? false : true"
      (paginationChanged)="onPaginationChanged()"
      (sortChanged)="onSortChanged($event)"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [immutableData]="inlineEdit"
      (cellFocused)="onCellFocused($event)"
      [getRowNodeId]="inlineEdit ? getRowNodeId : undefined"
      [suppressClickEdit]="isInlineGrid || isEOLGrid ? true : false"
      [sideBar]="sideBar"
      [ngClass]="{ isChekIniline: isChekIniline }"
      [rowModelType]="'clientSide'"
      [treeData]="treeData"
      [groupDefaultExpanded]="groupDefaultExpanded"
      [getDataPath]="getDataPath"
      [groupAggFiltering]="true"
      [animateRows]="isAnimateRows"
      [rowDragManaged]="true"
      (rowDragEnd)="rowDragged($event)"
      [enableCellTextSelection]="true"
    ></ag-grid-angular>
  </div>
</div>
